import { httpClient } from '@/utils/httpClient';
import { API_CONFIG } from '@/config/api';
import type { EmailSchedule, EmailScheduleInput, EmailScheduleRun } from '@/types/emailSchedule';

const SCHEDULES_ENDPOINT = API_CONFIG.ENDPOINTS.EMAIL_SCHEDULES;
const DEFAULT_EVENT_TYPE = 'thr_approaching_return_date_reminder';
const DEFAULT_CONDITION_KEY = 'thr_due_soon';

const buildPayload = (input: EmailScheduleInput) => {
  return {
    ...input,
    event_type: input.event_type ?? DEFAULT_EVENT_TYPE,
    condition_key: input.condition_key ?? DEFAULT_CONDITION_KEY,
    condition: input.condition ?? {},
    enabled: input.enabled ?? true,
  };
};

export const emailScheduleService = {
  async list(): Promise<EmailSchedule[]> {
    return httpClient.get<EmailSchedule[]>(SCHEDULES_ENDPOINT);
  },

  async create(input: EmailScheduleInput): Promise<EmailSchedule> {
    const payload = buildPayload(input);
    return httpClient.post<EmailSchedule>(SCHEDULES_ENDPOINT, payload);
  },

  async update(id: string, input: Partial<EmailScheduleInput>): Promise<EmailSchedule> {
    const payload: Record<string, unknown> = { ...input };

    if (input.event_type !== undefined) {
      payload.event_type = input.event_type ?? DEFAULT_EVENT_TYPE;
    }

    if (input.condition_key !== undefined) {
      payload.condition_key = input.condition_key ?? DEFAULT_CONDITION_KEY;
    }

    if (input.condition !== undefined) {
      payload.condition = input.condition ?? {};
    }

    if (input.enabled !== undefined) {
      payload.enabled = input.enabled;
    }

    return httpClient.patch<EmailSchedule>(`${SCHEDULES_ENDPOINT}/${id}`, payload);
  },

  async listRuns(scheduleId: string): Promise<EmailScheduleRun[]> {
    const query = new URLSearchParams({
      limit: '10',
    });
    return httpClient.get<EmailScheduleRun[]>(
      `${SCHEDULES_ENDPOINT}/${scheduleId}/runs?${query.toString()}`,
    );
  },
};
